module.exports = __webpack_public_path__ + "static/media/basic_charger.cf23319c.png";